"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    form: {
      type: Object
    },
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    bookingHeadWebId: {
      type: String,
      default: ''
    },
    bookingId: {
      type: String,
      default: ''
    },
    vgMDialogForm: {
      type: Object
    }
  },
  data: function data() {
    return {
      fileList: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    uploadFile: function uploadFile(item) {
      var _this = this;
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bookingHeadWebComId", this.bookingId);
      (0, _booking.excelImport3)(formDatas).then(function (res) {
        if (res.success) {
          if (res.errorMsg) {
            _this.$message.error(res.errorMsg);
          } else {
            if (res.msg) {
              _this.$confirm(res.msg, _this.$t('confirmMsg.title'), {
                showConfirmButton: false,
                closeOnClickModal: false,
                cancelButtonText: _this.$t('home.buttonClose'),
                type: 'warning'
              }).catch(function () {
                _this.$message.success(_this.$t("com.importSuccess"));
              });
            } else {
              _this.$message.success(_this.$t("com.importSuccess"));
            }
            // console.log(this.form.webBkContainerComs,'webBkContainerComs')
            // console.log(res.webBkContainerComs,'resContainer')
            // console.log(res.bkVgmContainers,'resVgmContainer')

            if (res.cargoDesc) {
              _this.form.cargoDesc = res.cargoDesc;
            }
            if (res.hsCode) {
              _this.form.hsCode = res.hsCode;
            }
            if (res.hsCodeCn) {
              _this.form.hsCodeCn = res.hsCodeCn;
            }
            if (res.hsCodeJp) {
              _this.form.hsCodeJp = res.hsCodeJp;
            }
            if (res.webBkContainerComs) {
              _this.form.webBkContainerComs = [];
              _this.form.deleteWebBkContainerComs = [];
              res.webBkContainerComs.forEach(function (item, index, arr) {
                if (item.rowStatus === 4) {
                  var data = {
                    containerNo: item.containerNo,
                    containerType: item.containerType,
                    sealNo1: item.sealNo1,
                    quantity: item.quantity,
                    weight: item.weight,
                    cntrSize: item.cntrSize,
                    cargoTypeCode: item.cargoTypeCode,
                    overLeft: item.overLeft,
                    overRight: item.overRight,
                    overHeight: item.overHeight,
                    overForeward: item.overForeward,
                    overAftward: item.overAftward,
                    socReturn: item.socReturn,
                    containerManager: item.containerManager,
                    rowStatus: 4
                  };
                  _this.form.webBkContainerComs.push(data);
                } else if (item.rowStatus === 8) {
                  _this.form.deleteWebBkContainerComs.push(item);
                }
              });
            }
            if (res.bkVgmContainers) {
              _this.vgMDialogForm.formVgm = [];
              _this.vgMDialogForm.deleteVgmList = [];
              res.bkVgmContainers.forEach(function (item, index, arr) {
                if (item.rowStatus === 4) {
                  var data = {
                    vesselCode: item.vesselCode,
                    voyageNo: item.voyageNo,
                    voyageLeg: item.voyageLeg,
                    bkNo: item.bkNo,
                    blNo: item.blNo,
                    containerNo: item.containerNo,
                    //location:'',
                    vgmGrossWeight: item.vgmGrossWeight,
                    vgmScale: item.vgmScale,
                    vgmDate: item.vgmDate,
                    remark: item.remark,
                    shipperOther: item.shipperOther,
                    shipperVgmPersonSig: item.shipperVgmPersonSig,
                    containerType: item.containerType,
                    vgmMethod: item.vgmMethod,
                    rowStatus: 4,
                    overWeight: null //箱信息的毛重
                  };
                  _this.vgMDialogForm.formVgm.push(data);
                } else if (item.rowStatus === 8) {
                  _this.vgMDialogForm.deleteVgmList.push(item);
                }
              });
            }
          }
          _this.$parent.vgmImportDialogVisible = false;
        } else {
          _this.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this.loading.close();
        _this.fileList = [];
        _this.$refs.upload.clearFiles();
      });
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      this.fileList.push(file);
      return isLt2M;
    },
    handleUploadFile: function handleUploadFile() {
      if (this.$refs.upload.uploadFiles.length === 0) {
        return this.$message.warning(this.$t("home.selectFileWaring"));
      }
      this.$refs.upload.submit();
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview: function handlePreview(file) {
      console.log(file);
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 3 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    opened: function opened() {
      //   this.handleSearch()
    },
    handleDownloadExcel: function handleDownloadExcel() {
      var link = document.createElement('a');
      link.href = '/static/excel/Container&VGM_Import_Format.xls'; // 指向你的 Word 文档路径
      link.download = 'Container&VGM_Import_Format.xls'; // 设置下载文件名
      link.click(); // 触发点击事件
    }
  }
};